import { LegService } from '@approot/services/leg/leg.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extraAttributesFilter'
})
export class ExtraAttributesFilterPipe implements PipeTransform {
  constructor(private legService: LegService) {}
  transform(shortName: string): any[] {
    return this.legService.activeExtraAttributes.filter(
      x => x.shortName === shortName
    );
  }
}
